<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
<!--      <div class="table-page-search-wrapper">-->
<!--        <a-form layout="inline">-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="关注fackbook奖励金币数" prop="facebookNum">-->
<!--                <a-input v-model="queryParam.facebookNum" placeholder="请输入关注fackbook奖励金币数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="关注youtube奖励金币数" prop="youtubeNum">-->
<!--                <a-input v-model="queryParam.youtubeNum" placeholder="请输入关注youtube奖励金币数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="关注tiktok奖励金币数" prop="tiktok">-->
<!--                  <a-input v-model="queryParam.tiktok" placeholder="请输入关注tiktok奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="打开消息通知奖励金币数" prop="openMessage">-->
<!--                  <a-input v-model="queryParam.openMessage" placeholder="请输入打开消息通知奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="设置爱好奖励金币数" prop="likeNum">-->
<!--                  <a-input v-model="queryParam.likeNum" placeholder="请输入设置爱好奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="观看一集广告奖励金币数" prop="advertisementNum">-->
<!--                  <a-input v-model="queryParam.advertisementNum" placeholder="请输入观看一集广告奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="观看市场5分钟奖励金币数" prop="lookVideoOne">-->
<!--                  <a-input v-model="queryParam.lookVideoOne" placeholder="请输入观看市场5分钟奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="观看市场10分钟奖励金币数" prop="lookVideoTwo">-->
<!--                  <a-input v-model="queryParam.lookVideoTwo" placeholder="请输入观看市场10分钟奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="观看市场15分钟奖励金币数" prop="lookVideoThree">-->
<!--                  <a-input v-model="queryParam.lookVideoThree" placeholder="请输入观看市场15分钟奖励金币数" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
<!--            <a-col :md="!advanced && 8 || 24" :sm="24">-->
<!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
<!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
<!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
<!--              </span>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-form>-->
<!--      </div>-->
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['taskConfig:taskConfig:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['taskConfig:taskConfig:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['taskConfig:taskConfig:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['taskConfig:taskConfig:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :scroll="{ x: 2000 }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['taskConfig:taskConfig:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['taskConfig:taskConfig:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['taskConfig:taskConfig:remove']" />
<!--          <a @click="handleDelete(record)" v-hasPermi="['taskConfig:taskConfig:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTaskConfig,listTaskConfig, delTaskConfig } from '@/api/taskConfig/taskConfig'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskConfig',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        facebookNum: null,
        youtubeNum: null,
        tiktok: null,
        openMessage: null,
        likeNum: null,
        advertisementNum: null,
        lookVideoOne: null,
        lookVideoTwo: null,
        lookVideoThree: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '关注fackbook奖励金币数',
          dataIndex: 'facebookNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '关注youtube奖励金币数',
          dataIndex: 'youtubeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '关注tiktok奖励金币数',
          dataIndex: 'tiktok',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '打开消息通知奖励金币数',
          dataIndex: 'openMessage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设置爱好奖励金币数',
          dataIndex: 'likeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '观看一集广告奖励金币数',
          dataIndex: 'advertisementNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '观看市场5分钟奖励金币数',
          dataIndex: 'lookVideoOne',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '观看市场10分钟奖励金币数',
          dataIndex: 'lookVideoTwo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '观看市场15分钟奖励金币数',
          dataIndex: 'lookVideoThree',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询任务奖励配置列表 */
    getList () {
      this.loading = true
     pageTaskConfig(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        facebookNum: undefined,
        youtubeNum: undefined,
        tiktok: undefined,
        openMessage: undefined,
        likeNum: undefined,
        advertisementNum: undefined,
        lookVideoOne: undefined,
        lookVideoTwo: undefined,
        lookVideoThree: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delTaskConfig(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('taskConfig/task-config/export', {
            ...that.queryParam
          }, `任务奖励配置_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
